

import { useParamsState } from '@/helpers'
import { useHostConversationList } from '@/services'

import styles from './host-conversation.module.css'

import { HostConversationTable, ConversationDrawerChat } from './components'

export const HostConversationList = () => {

    const [filter, setFilter] = useParamsState({
        search: '',
        page: '1',
        limit: '10',
    })

    const { data, isLoading } = useHostConversationList({
        params: {
            search: filter.search,
            page: filter.page,
            limit: filter.limit,
        },
    })

    const [queryParams, setQueryParams] = useParamsState({
        uuid: '',
        show: '',
        form: '',
    })

    const onHandleEditRegister = (uuid: string) => {
        setQueryParams({ ...queryParams, form: 'true', show: '', uuid })
    }


    const onHandleShowRegister = (uuid: string) => {
        setQueryParams({ ...queryParams, show: 'true', form: '', uuid })
    }



    return (
        <div className={styles.content}>
            <HostConversationTable
                data={data?.data}
                isLoading={isLoading}
                filter={filter}
                onSetFilter={setFilter}
                onHandleEditRegister={onHandleEditRegister}
                onHandleShowRegister={onHandleShowRegister}
            />

            <ConversationDrawerChat
                isOpen={queryParams.form === 'true'}
                onClose={() => setQueryParams({ ...queryParams, form: '' })}
                uuid={queryParams.uuid}
            />

            {/*
      <ConversationDrawerShow
        isOpen={queryParams.show === 'true'}
        onHandleOpen={() => setQueryParams({ ...queryParams, show: '' })}
        uuid={queryParams.uuid}
        variation="acquisition"
      /> */}
        </div>
    )
}
